import styled from "styled-components";
import "../../../styles/sass/Pages/_newDesign.scss";

export const Container = styled.div.withConfig({
	shouldForwardProp: (props) => props !== "error",
})`
	display: flex;
	align-items: center;

	color: #ffffff;
	font-size: 16px;
	width: 100%;
	height: 56px;

	input[type="tel"] {
		border-radius: 8px;
		border: solid 2px var(--neutral-strong) !important;

		&:focus-within {
			border-color: ${(props) =>
				!props.error ? "var(--brand-primary)" : "var(--feedback-error)"} !important;
		}
	}
`;
